import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Indianapolis.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Mobile App Development Indianapolis</h2>
            <p>
              You can easily rely on TekRevol's expertise for mobile app
              development Indianapolis – where innovation meets excellence. With
              our customized approach, we enable your business to drive towards
              sustainable growth. We have a track record of delivering top-notch
              mobile apps that have set a trend in the industry. Our team crafts
              innovative app solutions that meet your business needs and
              objectives. That’s how we ensure a solution that fits your precise
              requirements. As one of the leading mobile app development
              companies in Indianapolis, we stay updated with the evolving
              technology trends. It enables us to use the latest tools and
              frameworks to create innovative and future-oriented apps. So,
              consult with us to create something inventive that marks your
              separate territory in the industry.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
